import { useRef, useState } from 'react';

import { Label, Period, TimePeriodSelect, TimePicker } from '@crossnokaye/ux-common';

import { Inline } from '@/ux-common/components/inline/inline';

export interface DefrostScheduleTimePickerProps {
  className?: string;
  date: Date | undefined;
  disabled?: boolean;
  setDate: (date: Date | undefined) => void;
}

export const DefrostScheduleTimePicker = ({
  className,
  date,
  disabled,
  setDate,
}: DefrostScheduleTimePickerProps) => {
  const hours = date?.getHours() ?? 0;
  const [period, setPeriod] = useState<Period>(hours >= 12 ? 'PM' : 'AM');

  const minuteRef = useRef<HTMLInputElement>(null);
  const hourRef = useRef<HTMLInputElement>(null);
  const periodRef = useRef<HTMLButtonElement>(null);

  return (
    <Inline className={`inline-row-sm flex-nowrap ${className}`}>
      <TimePicker
        className="w-fit"
        date={date}
        disabled={disabled}
        onRightFocus={() => minuteRef.current?.focus()}
        period={period}
        picker="12hours"
        ref={hourRef}
        setDate={setDate}
      />
      <Label className="text-lg font-medium text-foreground" data-component="DateTimePickerColon">
        :
      </Label>
      <TimePicker
        className="w-fit"
        date={date}
        disabled={disabled}
        onLeftFocus={() => hourRef.current?.focus()}
        onRightFocus={() => periodRef.current?.focus()}
        picker="minutes"
        ref={minuteRef}
        setDate={setDate}
      />
      <TimePeriodSelect
        className="w-fit"
        date={date}
        disabled={disabled}
        onLeftFocus={() => minuteRef.current?.focus()}
        period={period}
        ref={periodRef}
        setDate={setDate}
        setPeriod={setPeriod}
      />
    </Inline>
  );
};
